<template>
        <div>
            <h2>Relatório de Clientes</h2>
        <div class="d-flex w-100">

            <div class="text-center mt-5 mb-5">
                <v-menu>
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" v-on="on" large>
                            Gerar Relatorio
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item v-for="(item, index) in actions" :key="index" :value="index" @click="item.handle"
                            class="cursor-pointer">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>

                </v-menu>

                <v-btn class="ml-5" @click="openModalFilter = true" large color="primary" outlined>
                    Filtro
                    <v-icon>mdi-filter</v-icon>
                </v-btn>

            </div>

        </div>
            
            <v-simple-table dense>
                <thead>
                    <tr>
                        <th>CÓD.</th>
                        <th>Nome</th>
                        <th>Vendedor</th>
                        <th>Segmento</th>
                        <th>Cidade</th>
                        <th>Estado</th>
                        <th>Telefone</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dado in dadosTabela" :key="dado._id">
                        <td style="padding: 20px">{{ dado.codigo }}</td>
                        <td>
                            <strong>{{ dado.razaoSocial }}</strong>
                        </td>
                        <td>{{ dado.vendedorNome }}</td>
                        <td>{{ dado.segmentoDeMercadoDescricao }}</td>
                        <td>{{ dado.entregaCidadeNome }}</td>
                        <td>{{ dado.entregaEstadoNome }}</td>
                        <td>{{ '-' }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
            <modal-filter-client-view 
                :open="openModalFilter" 
                @close="openModalFilter = false" 
                @filter-applied="aplicateFilter"
                v-model="filter"
            />

            <relatorio-cliente-preview 
                :isOpen="openPreview"
                :dados-tabela="dadosTabela" 
                :filters="filter"
                @exportPdf="gerarPDF"
                @cancel="openPreview = false"
            />
        </div>
</template>

<script>
import Vue from 'vue';
import * as XLSX from 'xlsx'
import moment from 'moment'
import html2pdf from 'html2pdf.js'
import ModalFilterClientView from './ModalFilterClientView..vue';
import RelatorioClientePreview from './RelatorioClientePreview.vue';

export default {
  components: { ModalFilterClientView, RelatorioClientePreview },
    name: 'RelatorioUser',
    data() {
        return {
            filter: {
                dataInicio: null,
                dataFim: null,
                codigo: null,
                vendedor: null,
                segmento: null,
                estado: null
            },
            openPreview: false,
            openModalFilter: false,
            actions: [
                {
                    title: "Gerar XLS",
                    handle: () => {
                        this.exportToExcel()
                    }
                },
                {
                    title: "Gerar PDF",
                    handle: () => {
                        this.openPreview = true
                    }
                }
            ],
            dadosTabela: []
        }
    },
    
    methods: {
        async getRelatorioClientes(){
            const response = await Vue.prototype.$http.post('/View/run', {
                    params: [
                        { dataType: "String", name: "dataInicio", value: this.filter.dataInicio ? moment(this.filter.dataInicio).format('YYYY-MM-DD') : moment('1970-01-01').format('YYYY-MM-DD') },
                        { dataType: "String", name: "dataFim", value: this.filter.dataFim ? moment(this.filter.dataFim).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD') },
                        { dataType: "string", name: "codigo", value: this.filter.codigo },
                        { dataType: "string", name: "vendedor", value: this.filter.vendedor },
                        { dataType: "string", name: "segmento", value: this.filter.segmento },
                        { dataType: "string", name: "estado", value: this.filter.estado },
                        { dataType: "string", name: "order", value: "razaoSocial" },
                        { dataType: "Number", name: "desc", value: this.filter.order ? Number(this.filter.order) : 1 }
                    ],
                    viewId: "63f82c5d-d805-4a1d-abd4-32efd6de0408",
                    page: 1,
                    limit: 3000000

            })
            this.dadosTabela = response.data.data.data
        },

        aplicateFilter(newFilter) {
            this.filter = { ...newFilter }
            this.getRelatorioClientes()
        },

        exportToExcel() {

            const dataRelatorio = this.dadosTabela.map((item) => {
                return {
                    'Código': item.codigo,
                    'Nome': item.razaoSocial,
                    'Vendedor': item.vendedorNome,
                    'Cidade': item.entregaCidadeNome,
                    'Telefone': '-'
                }
            })

            const ws = XLSX.utils.json_to_sheet(dataRelatorio)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'Contatos')

            // Cria e baixa o arquivo
            XLSX.writeFile(wb, 'contatos.xlsx')
        },

        gerarPDF() {
            const elemento = document.getElementById("conteudoPDF");
            html2pdf()
            .set({
                margin: 10,
                filename: 'Relatorio-Clientes.pdf',
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
            })
            .from(elemento)
            .save();
        }
    },

    async created(){
        await this.getRelatorioClientes()
    }
}
</script>